export default __webpack_public_path__ + "static/media/1_0092.1065b670.webp";